module.exports = __webpack_public_path__ + "static/media/cloud-upload-alt.acd0b0f1.svg";